import React from "react";
import { Navigate } from "react-router-dom";
import { isAdminAuthenticated } from "lib/auth/session";
import { PATHS } from "data/paths";

export default function ProtectedRoute({ children }) {
  if (!isAdminAuthenticated()) {
    return <Navigate to={PATHS.login} replace />;
  }

  return children;
}
